import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const UrlNormalizer = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const normalizeUrl = () => {
            try {
                let { pathname, search } = location;

                if (pathname === '/newsfeed/') {
                    return;
                }

                pathname = pathname.replace(/\/+/g, '/');
                if (pathname !== '/' && pathname.endsWith('/')) {
                    pathname = pathname.slice(0, -1);
                }
                pathname = pathname.toLowerCase();
                if (pathname.endsWith('/index.html')) {
                    pathname = pathname.slice(0, -10);
                }

                const searchParams = new URLSearchParams(search);
                const sortedSearch = new URLSearchParams([...searchParams.entries()].sort()).toString();
                search = sortedSearch ? `?${sortedSearch}` : '';

                const normalizedUrl = `${pathname}${search}`;
                if (location.pathname + location.search !== normalizedUrl) {
                    navigate(normalizedUrl, { replace: true });
                }
            } catch (error) {
                //console.error('URL Normalization Error:', error);
            }
        };

        normalizeUrl();
    }, [location, navigate]);

    return null;
};

export default UrlNormalizer;
